import Layout from "components/layout";
import React from "react";
import WebsiteTranslation from "components/reusableComponents/staticPages/websiteTranslation/index";
import SEO from "components/seo";

export default function index() {
  const title = "Website Translation Services | Tomedes";
  const description =
    "Tomedes provides website translation services in the context of localization projects to extend marketing reach.";
  const keywords =
    "professional website translation, website translation quote";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/website-translation.php"
      />
      <WebsiteTranslation />
    </Layout>
  );
}
